export default __webpack_public_path__ + "static/media/grocery11.91454a27.jpeg";